/** Compte PCG générique + sous-compte optionnel (cabinet). */
import { Field } from "../components/Field";
import { pcgFull, type PcgAccount } from "./pcg";

type PcgFieldsProps = {
  accounts: PcgAccount[];
  code: string;
  sub: string;
  onCode: (v: string) => void;
  onSub: (v: string) => void;
  codeLabel?: string;
  subLabel?: string;
};

export function PcgFields({
  accounts,
  code,
  sub,
  onCode,
  onSub,
  codeLabel = "Compte comptable",
  subLabel = "Sous-compte",
}: PcgFieldsProps) {
  const full = pcgFull(code, sub);
  const extras = code && !accounts.some((a) => a.code === code) ? [{ code, label: code }] : [];
  const options = [...accounts, ...extras];

  return (
    <div className="grid w-full gap-4 sm:grid-cols-2">
      <label className="fx-field flex flex-col gap-1 text-xs" htmlFor="pcg_code">
        {codeLabel}
        <select
          id="pcg_code"
          className="rounded-md border px-2.5 py-2 text-sm"
          value={code}
          onChange={(e) => onCode(e.target.value)}
        >
          {options.map((a) => (
            <option key={a.code} value={a.code}>
              {a.code} — {a.label}
            </option>
          ))}
        </select>
      </label>
      <Field
        label={subLabel}
        name="pcg_sub"
        inputMode="numeric"
        value={sub}
        placeholder="100"
        hint={full ? `Compte retenu : ${full}` : "Optionnel — le cabinet pose souvent 706100, 411001…"}
        autoComplete="off"
        onChange={(e) => onSub(e.target.value.replace(/\D/g, "").slice(0, 8))}
      />
    </div>
  );
}
